import axios from "axios";
import { useEffect, useState } from "react";
import Login from "./login";
import Signup1 from "./signup1";
import Signup2 from "./signup2";
import Signup3 from "./signup3";

const Login_Signup = ({trigger,handleCloseShow}) => {

    const [page,setPage]=useState(trigger)
    const [email, setEmail] = useState('');
    const [first_name, setFirstName] = useState('');
    const [last_name, setLastName] = useState('');
    const [phone_number, setContactNumber] = useState('');
    const [password, setCreatePassword] = useState('ok');
    const [confirmPassword, setConfirmPassword] = useState('notok');


    const handleEmailChange = (e) => {
        setEmail(e.target.value);
      };
    
      const handleFirstNameChange = (e) => {
        setFirstName(e.target.value);
      };
    
      const handleLastNameChange = (e) => {
        setLastName(e.target.value);
      };
    
      const handleContactNumberChange = (e) => {
        setContactNumber(e.target.value);
      };
    
      const handleCreatePasswordChange = (e) => {
        //console.log(e.target.value)
        setCreatePassword(e.target.value);
      };
    
      const handleConfirmPasswordChange = (e) => {
        //console.log(e.target.value)
        setConfirmPassword(e.target.value);
      };

      

      let userData = {
        email,
        password,
        first_name,
        last_name,
        phone_number,
      }
      const registerUser = async (userData) => {
        try {
          //console.log(userData)
          const response = await axios.post('http://localhost:8000/api/v1/signupuser', userData
          );
          //console.log(response.data); // handle response data here
        } catch (error) {
          console.error(error); // handle error here
        }
      };  
      const handleEqualCheckPassword = () => {
        registerUser(userData)
            handlePage(3)
        
      };
    const handlePage = (a)=>{
        setPage(a)
        if(a===-1) {handleCloseShow()}
    }
    useEffect(()=>{
        setPage(trigger)
    },[trigger])
    
    return(
    <div className="fixed  z-[100] w-full">
        {page===0?(<>
        <Login handlePage={handlePage}/>
        </>):(<></>)}
        {page===1?(<>
        <Signup1 handlePage={handlePage} handleEmailChange={handleEmailChange}/>
        </>):(<></>)}
        {page===2?(<>
        <Signup3 handlePage={handlePage} handleFirstNameChange={handleFirstNameChange}
          handleLastNameChange={handleLastNameChange}
          handleContactNumberChange={handleContactNumberChange}
          handleCreatePasswordChange={handleCreatePasswordChange}
          handleConfirmPasswordChange={handleConfirmPasswordChange}
          handleEqualCheckPassword={handleEqualCheckPassword}
         
          />
          
        </>):(<></>)}
        {page===3?(<>
        <Signup2 handlePage={handlePage}/>
        </>):(<></>)}
    </div>
    )
}

export default Login_Signup;